import { render, staticRenderFns } from "./schema.vue?vue&type=template&id=696f5196&scoped=true"
import script from "./schema.vue?vue&type=script&lang=js"
export * from "./schema.vue?vue&type=script&lang=js"
import style0 from "./schema.vue?vue&type=style&index=0&id=696f5196&prod&scoped=true&lang=scss"
import style1 from "./schema.vue?vue&type=style&index=1&id=696f5196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696f5196",
  null
  
)

export default component.exports